import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .AddContact {
    max-width: 470px;
    width: 100%;
    :global(.RadioButton) {
      &:first-child {
        margin: 0 0 13px 0;
      }
    }

    :global(&__controls) {
      margin-bottom: 23px;
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global``;
};

export { staticStyles, getDynamicStyles };
